import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import { H2 } from 'components/common/Text/Text'
import VehicleImage from 'components/common/VehicleImage'
import { getMonthNameBySequenceNumber } from 'helpers/months'

const VechicleInfo = ({
  isTrailer,
  formattedTireSize,
  vehicle: {
    masterVehicle: {
      yearDesc,
      makeDesc,
      modelDesc,
      subModelDesc
    } = {},
    vehicleColor,
    vehicleNickname
  } = {},
  timeSlot: {
    day,
    dayOfWeek,
    month,
    timeSlot,
    year
  } = {}
}) =>
  <Wrapper data-at-appointment-vehicleinfo>
    <ImageWrapper data-at-vehicleinfo-img>
      {
        isTrailer ?
          <TrailerIcon asset="icon-trailer" alt="Trailer" /> :
          <VehicleImage
            make={ makeDesc }
            model={ modelDesc }
            submodel={ subModelDesc }
            year={ parseInt(yearDesc, 10) }
            height={ 70 }
            width={ 140 }
            color={ vehicleColor ? `#${vehicleColor}` : undefined } />
      }
    </ImageWrapper>
    {
      isTrailer ?
        <Fragment>
          <TrailerModel data-at-vehicleinfo-trailername noMargin>{ vehicleNickname }</TrailerModel>
          <Size data-at-vehicleinfo-trailersize>{ formattedTireSize }</Size>
        </Fragment> :
        <CarModel data-at-vehicleinfo-vehiclename>{ vehicleNickname }</CarModel>
    }

    <Time data-at-vehicleinfo-date>{ dayOfWeek }, { getMonthNameBySequenceNumber(month) } { day }, { year }</Time>
    <Time data-at-vehicleinfo-time lowercase>{ timeSlot }</Time>
  </Wrapper>

VechicleInfo.propTypes = {
  formattedTireSize: PropTypes.string,
  isTrailer: PropTypes.bool,
  timeSlot: PropTypes.shape(),
  vehicle: PropTypes.shape()
}

export default VechicleInfo

const Wrapper = styled.div`
  padding: 30px 20px 13px;
  border: 1px solid ${Theme.colors.light_grey};
  ${Media.desktop`
    display: table-cell;
    width: 313px;
    height: 220px;
    vertical-align: top;
  `}
`

const Size = styled.div`
  margin-bottom: 5px;
  font-size: 12px;
  line-height: 17px;
`

const CarModel = styled.h2`
  margin: 15px 0 10px;
  text-transform: capitalize;
  ${Mixin.font.GothamBold(18, 600, 24)}
`

const TrailerModel = styled(H2)`
  text-transform: capitalize;
  ${Mixin.font.GothamBold(18, 600, 24)}
`

const Time = styled.div`
  font-weight: 600;
  line-height: 22px;
  ${props => props.lowercase && css`
    text-transform: lowercase;
  `}
`

const ImageWrapper = styled.div`
  text-align: center;
  width: 150px;
  margin: 5px auto;
`

const TrailerIcon = styled(Icon)`
  height: 80px;
  margin-bottom: 25px;
`
